import ABCyaPhaser from "@abcya/abcya_phaser";

export function dotPop(obj, time, wait, override) {
    if (!override) override = true;
    if (!wait) wait = 0;
    if (!time) time = 320;
    return obj.scene.tweens.timeline({
        tweens:[
            ABCyaPhaser.Tweens.createTween(obj, 240, {delay: wait, scale: 1.6, alpha: 1}, Phaser.Math.Easing.Quadratic.In),
            ABCyaPhaser.Tweens.createTween(obj, time, {scale: 1, alpha: 1}, Phaser.Math.Easing.Quadratic.Out),
        ]
    });
}